/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson } from '../lib/api.js';
import { COMMENT_MAX_CHARS, PB_URL } from '../lib/config.js';
import { avatarUrl } from '../lib/pixels.js';
import { playBlip } from '../lib/sound.js';
import { relTime } from '../lib/text.js';

export default {
  /** Een reactie uit wat we hier hebben weghalen, waar hij ook bij hoorde. */
  vergeetComment(id) {
      if (!id) return;
      const oud = this.state.comments || {};
      let weg = false;
      const nieuw = {};
      Object.keys(oud).forEach((k) => {
        const lijst = oud[k] || [];
        const over = lijst.filter((c) => c.id !== id);
        if (over.length !== lijst.length) weg = true;
        nieuw[k] = over;
      });
      if (weg) this.setState({ comments: nieuw });
    },

  async fetchComments() {
      try {
        // Reacties horen bij iemands eigen krabbel: geen limiet. Alleen bij de
        // eerste keer lopen we alle pagina's af; daarna halen we enkel op wat er
        // sinds de laatste keer bij kwam, zodat het pollen licht blijft.
        const since = this.lastCommentAt;
        const q = since ? `&filter=${encodeURIComponent(`created>"${since}"`)}` : '';
        const all = [];
        for (let page = 1; page <= 20; page++) {
          const res = await api(`${PB_URL}/api/collections/paal_comments/records?sort=created&perPage=500&page=${page}${q}`);
          if (!res.ok) return;
          const data = await res.json();
          all.push.apply(all, data.items || []);
          if (page >= (data.totalPages || 1)) break;
        }
        if (all.length) this.lastCommentAt = all[all.length - 1].created;
        // Niets nieuws? Dan laten we de bestaande reacties met rust.
        if (since && !all.length) return;
        if (since) {
          const merged = {};
          Object.keys(this.state.comments || {}).forEach((k) => { merged[k] = (this.state.comments[k] || []).slice(); });
          all.forEach((r) => {
            const key = r.drawingId || '';
            if (!key) return;
            const list = (merged[key] = merged[key] || []);
            if (list.some((c) => c.id === r.id)) return;
            list.push({ id: r.id, author: r.author || 'onbekend', accountId: r.accountId || '', text: r.text || '', created: r.created || '' });
          });
          this.setState({ comments: merged });
          return;
        }
        const map = {};
        all.forEach((r) => {
          const key = r.drawingId || '';
          if (!key) return;
          (map[key] = map[key] || []).push({
            id: r.id, author: r.author || 'onbekend', accountId: r.accountId || '', text: r.text || '', created: r.created || ''
          });
        });
        this.setState({ comments: map });
      } catch (e) {}
    },

  onCommentInput(e) { return this.setState({ commentText: e.target.value, commentError: '' }); },

  async submitComment() {
      const text = (this.state.commentText || '').trim();
      const id = this.state.viewerId;
      if (!id || this.state.commentSending) return;
      if (!text) return;
      if (this.myCommentOn(id)) { this.setState({ commentError: 'Je hebt al gereageerd op deze krabbel.' }); return; }
      if (text.length > COMMENT_MAX_CHARS) { this.setState({ commentError: 'Iets korter graag: maximaal ' + COMMENT_MAX_CHARS + ' tekens.' }); return; }
      if (!this.ensureName('Log in of maak een account aan om te kunnen reageren op een krabbel.')) return;
      this.setState({ commentSending: true, commentError: '' });
      try {
        const res = await api(`${PB_URL}/api/collections/paal_comments/records`, asJson('POST', { drawingId: id, author: this.state.author || '', accountId: this.state.accountId || '', text }));
        if (!res.ok) throw new Error(res.status === 404 ? 'missing' : String(res.status));
        playBlip();
        this.setState({ commentSending: false, commentText: '' }, this.fetchComments);
      } catch (e) {
        this.setState({
          commentSending: false,
          commentError: e.message === 'missing'
            ? 'Maak op de server de collectie paal_comments aan met velden drawingId, author, accountId en text (tekst).'
            : 'Je reactie kon niet verstuurd worden. Probeer het nog eens.'
        });
      }
    },

  async deleteComment(cid) {
      const list = (this.state.comments || {})[this.state.viewerId] || [];
      this.setState({ comments: Object.assign({}, this.state.comments, { [this.state.viewerId]: list.filter((c) => c.id !== cid) }) });
      try { await api(`${PB_URL}/api/collections/paal_comments/records/${cid}`, { method: 'DELETE' }); } catch (e) {}
      this.lastCommentAt = null;
      this.fetchComments();
    },

  myCommentOn(drawingId) {
      const myId = this.state.accountId || '';
      return ((this.state.comments || {})[drawingId] || []).find((c) =>
        (myId && c.accountId === myId) || (!c.accountId && c.author === this.state.author)) || null;
    },

  commentVals(viewer) {
      const list = viewer ? ((this.state.comments || {})[viewer.id] || []) : [];
      const already = viewer ? !!this.myCommentOn(viewer.id) : false;
      const text = this.state.commentText || '';
      const n = text.length;
      const over = n > COMMENT_MAX_CHARS;
      const myId = this.state.accountId || '';
      const accById = {};
      (this.state.accounts || []).forEach((a) => { accById[a.id] = a; });
      return {
        hasComments: list.length > 0,
        viewerComments: list.map((c) => {
          const acc = accById[c.accountId];
          const mine = !!(myId && c.accountId === myId);
          return {
            text: c.text,
            author: c.author,
            when: relTime(c.created),
            avatarUrl: avatarUrl(acc ? acc.avatar : ''),
            canDelete: mine || this.isMaintainer,
            onDelete: () => this.deleteComment(c.id),
            bubbleStyle: {
              display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', minWidth: '0', boxSizing: 'border-box',
              background: mine ? 'var(--lila)' : 'var(--lila)', border: '2px solid var(--rand-stippel)', borderRadius: '12px',
              padding: '11px 13px'
            }
          };
        }),
        showCommentForm: !already,
        commentDone: already,
        commentText: text,
        onCommentInput: this.onCommentInput,
        onCommentKey: (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.submitComment(); } },
        submitComment: this.submitComment,
        commentSending: !!this.state.commentSending,
        commentBlocked: !!this.state.commentSending || over || n === 0,
        commentWordLabel: n + '/' + COMMENT_MAX_CHARS + ' tekens',
        commentWordStyle: {
          fontSize: '11px', fontWeight: 700, paddingLeft: '15px',
          color: over ? 'var(--fout)' : (n > COMMENT_MAX_CHARS - 10 ? 'var(--geel-ink)' : 'var(--tekst-3)')
        },
        hasCommentError: !!this.state.commentError,
        commentError: this.state.commentError || ''
      };
    }
};
